// Traductions arabes — Arabe Standard Moderne (فصحى) registre simple
// Termes administratifs français conservés dans les leçons
// RTL — direction: rtl

export const AR = {
  lang: 'ar',
  dir: 'rtl',

  nav: {
    home: 'الرئيسية',
    back: 'رجوع',
    modules: 'الدروس',
    about: 'من نحن',
    start: 'ابدأ',
    close: 'إغلاق',
    jeexplique: 'كيفاش يخدم',
    guide: 'دليل',
    textLarger: 'نص أكبر ؟',
  },

  // Home — Hero
  hero: {
    tag: '✦ مجاني · بدون تسجيل · بدون حكم',
    title: 'مشاورك الإداري الرقمي،\nبلغة واضحة وبسيطة.',
    subtitle: 'DémarchesClaires يرشدك خطوة بخطوة في إجراءاتك الإدارية الإلكترونية — رسائل CAF، ملء PDF، الإيميلات، الملفات. في 5 دقائق، تفهم وتتصرف.',
    cta: 'ابدأ مجاناً ←',
    explain: 'كيف يعمل الموقع؟ 😊',
    badge: '✦ 3 أسئلة سريعة ← مسارك الشخصي مباشرةً',
  },

  // Stats home
  stats: {
    modules: 'موضوعات يومية',
    lessons: 'درساً متاحاً',
    lessonsCompleted: 'درساً مكتملاً',
    free: 'مجاني للأبد',
    sourceBtn: '📰 اقرأ المصدر',
    statsTitle: '📊 في فرنسا اليوم',
    stat1num: '15%', stat1label: 'من السكان في وضع الإقصاء الرقمي (INSEE 2023)',
    stat2num: '28%', stat2label: 'لديهم كفاءات رقمية ضعيفة (Crédoc 2022)',
    stat3num: '29%', stat3label: 'لم ينجزوا أي إجراء إداري إلكتروني في 12 شهراً (Crédoc 2022)',
  },

  // Témoignages
  testimonials: {
    title: '💬 شهاداتهم',
    t1: { name: 'كلوديت، 71 سنة — Creuse', text: 'كنت أفوّت مواعيد Ameli لأنني لا أعرف كيف أتصل. الآن أدير كل شيء وحدي.' },
    t2: { name: 'رشيد، 44 سنة — Seine-Saint-Denis', text: 'لم أكن أصرّح بالضرائب إلكترونياً قط. بفضل الدرس المخصص، أنجزت كل شيء وحدي في 20 دقيقة.' },
  },

  // Marie persona
  persona: {
    sectionTitle: 'يشبهوننا',
    name: 'مريم، 62 سنة',
    story: 'تلقّت رسالة من CAF تطلب منها وثائق خلال 15 يوماً. اللغة الإدارية، ملء PDF، تصوير الوثائق وإرفاقها... كل هذا يتجاوزها. القلق يتصاعد.',
    result: '✓ مع DémarchesClaires، أتمّت مريم إجراءاتها وحدها في أيام قليلة. الثقة عادت.',
  },

  // IA section
  ia: {
    title: 'الذكاء الاصطناعي في قلب DémarchesClaires',
    desc: 'ليس درساً نظرياً. ذكاء اصطناعي يراقب ويتكيّف ويرشدك شخصياً.',
    features: [
      { icon: '🎯', label: 'تشخيص', desc: 'يُقيّم مستواك' },
      { icon: '🔄', label: 'مسار شخصي', desc: 'مُكيَّف لك' },
      { icon: '💡', label: 'تغذية راجعة', desc: 'يشرح الأخطاء' },
    ],
  },

  // Modules section
  modules: {
    sectionTitle: '📚 جميع الوحدات',
    title: 'اختر وحدتك',
    subtitle: 'كل وحدة تحل مشكلة يومية ملموسة',
    lessons: 'دروس',
    completed: 'مكتمل',
    progress: 'تقدمك',
    start: 'ابدأ الدرس ←',
    continue: 'تابع ←',
    done: '✓ مكتمل',
    lessonsCount: 'دروس مكتملة',
  },

  moduleNames: {
    courrier:       'فهم الخطابات الرسمية',
    pdf:            'ملء PDF',
    email:          'البريد الإلكتروني',
    dossier:        'تجميع الملف',
    securite:       'الأمان الرقمي',
    impots:         'التصريح بالضرائب',
    cartevitale:    'البطاقة الحيوية والصحة',
    rsacaf:         'كل شيء عن CAF',
    logement:       'السكن و APL',
    dossiermedical: 'الملف الطبي',
    formation:      'التكوين المهني',
    permis:         'رخصة القيادة',
    banque:         'الحساب البنكي',
    smartphone:     'الهاتف الذكي للمبتدئين',
  },

  lesson: {
    context: 'الوضعية',
    question: 'السؤال',
    validate: 'تأكيد ✓',
    correct: '✅ إجابة صحيحة!',
    wrong: '❌ إجابة خاطئة',
    next: 'الدرس التالي ←',
    finish: '🎉 إنهاء الدرس',
    explanation: 'الشرح',
    lessonOf: 'درس {n} من {total}',
  },

  moduleEnd: {
    congrats: '🎉',
    title: 'أنهيت الدرس!',
    desc: 'أحسنت! أكملت درس',
    desc2: 'كل خطوة تعلّمتها هي ورقة أقل تخيفك. واصل!',
    nextModule: 'الدرس التالي',
    allModules: 'جميع الدروس',
    retry: 'راجع هذا الدرس',
    allDone: '🏆 أكملت جميع الدروس!',
    stats: { lessons: 'دروس', completed: 'مكتمل', badge: 'شارة' },
  },

  onboarding: {
    title: 'أهلاً بك 👋',
    subtitle: 'أجب على 3 أسئلة لنوجّهك بشكل أفضل',
    skip: 'تخطّى وابدأ مباشرة →',
    cta: 'انطلق! →',
    allModules: 'شاهد كل الدروس',
    questions: [
      {
        id: 'defi',
        question: 'ما هو أكبر تحدٍّ تواجهه الآن؟',
        emoji: '🎯',
        options: [
          { id: 'courrier', text: '📬 أتلقى رسائل من CAF أو CPAM أو الضرائب لا أفهمها', module: 'courrier' },
          { id: 'pdf', text: '📄 أحتاج إلى ملء نماذج PDF ولا أعرف كيف', module: 'pdf' },
          { id: 'email', text: '✉️ أجد صعوبة في إرسال إيميلات مع المرفقات', module: 'email' },
          { id: 'dossier', text: '📁 أحتاج إلى تجميع ملف وجمع الوثائق', module: 'dossier' },
          { id: 'securite', text: '🔒 أخاف من الاحتيال وأريد حماية بياناتي', module: 'securite' },
          { id: 'impots', text: '🧾 أحتاج إلى تقديم إقرار الضرائب ولا أعرف كيف', module: 'impots' },
          { id: 'cartevitale', text: '💊 لدي أسئلة حول بطاقة Vitale أو التعويضات', module: 'cartevitale' },
          { id: 'rsacaf', text: '🏛️ أريد معرفة حقوقي في CAF — RSA، المنح، المساعدات', module: 'rsacaf' },
          { id: 'logement', text: '🏠 أبحث عن سكن اجتماعي أو أريد فهم حقوقي', module: 'logement' },
          { id: 'dossiermedical', text: '🏥 أريد الوصول إلى ملفي الطبي أو تنظيم وثائق صحتي', module: 'dossiermedical' },
        ]
      },
      {
        id: 'niveau',
        question: 'تعتبر نفسك...',
        emoji: '📊',
        options: [
          { id: 'debutant', text: '🌱 مبتدئ — الرقمي يخيفني' },
          { id: 'moyen', text: '🌿 مرتاح نوعاً ما — أتدبّر لكن لدي صعوبات' },
          { id: 'avance', text: '🌳 مرتاح — أريد فقط فهم الإجراءات الإدارية' },
        ]
      },
      {
        id: 'appareil',
        question: 'تستخدم عادةً...',
        emoji: '📱',
        options: [
          { id: 'telephone', text: '📱 هاتفي' },
          { id: 'ordinateur', text: '💻 حاسوبي' },
          { id: 'les_deux', text: '📱💻 كليهما' },
        ]
      },
    ],
    messages: {
      courrier: { titre: 'لنبدأ بالرسائل الرسمية', desc: 'هنا غالباً تتعقّد الأمور. سنكشف الغموض معاً.', module: 'courrier' },
      pdf: { titre: 'لننجز ملفات PDF', desc: 'ملء نموذج PDF بلا توتر — ممكن. سنريك كيف.', module: 'pdf' },
      email: { titre: 'لنتقن الإيميلات', desc: 'إرسال المرفقات، التعرف على الاحتيال — خطوة بخطوة.', module: 'email' },
      dossier: { titre: 'لنجمع ملفك', desc: 'الوثائق الصحيحة في الوقت المناسب — سنوجّهك.', module: 'dossier' },
      securite: { titre: 'لنحمي بياناتك', desc: 'التعرف على الاحتيال، تأمين حساباتك — ستطمئن.', module: 'securite' },
      impots: { titre: 'لنقدّم إقرار الضرائب معاً', desc: 'خطوة بخطوة على impots.gouv.fr — في دقائق ينتهي.', module: 'impots' },
      cartevitale: { titre: 'لنتقن بطاقة Vitale', desc: 'Ameli، التعويضات، التحديث — سنشرح كل شيء.', module: 'cartevitale' },
      rsacaf: { titre: 'لنكتشف ما يمكن لـ CAF أن تقدمه لك', desc: 'RSA، المنح، PAJE — احسب حقوقك في دقائق.', module: 'rsacaf' },
      logement: { titre: 'لنجد سكنك', desc: 'طلب السكن الاجتماعي، APL، حقوق المستأجر — خطوة بخطوة.', module: 'logement' },
      dossiermedical: { titre: 'لندير ملفك الطبي', desc: 'Mon Espace Santé، الوصفات، حقوق المريض — كل شيء مشروح.', module: 'dossiermedical' },
    },
  },

  about: {
    tag: 'من نحن',
    title: 'DémarchesClaires — الإدارة للجميع',
    mission: 'مشروع مجاني ومفتوح المصدر، يساعد الأشخاص الذين يعانون من الإقصاء الرقمي في إنجاز إجراءاتهم الإدارية الإلكترونية.',
    persona: 'مريم، 62 سنة، تلقّت رسالة من CAF تطلب وثائق في 15 يوماً. DémarchesClaires أتاح لها إتمام كل شيء وحدها.',
    team: 'الفريق',
    openSource: 'مشروع مفتوح المصدر',
  },

  footer: {
    home: 'الرئيسية',
    modules: 'الدروس',
    progress: 'تقدمي',
    about: 'من نحن',
    contact: 'تواصل معنا',
    mention: 'مشروع مدني · مفتوح المصدر · بيانات محمية',
  },

  burger: {
    navigation: 'التنقل',
    modules: 'الدروس',
    home: 'الرئيسية',
    about: 'من نحن',
    language: 'اللغة',
  },

  badges: {
    courrier:       'خبير الخطابات',
    pdf:            'خبير PDF',
    email:          'خبير البريد الإلكتروني',
    dossier:        'خبير الملفات',
    securite:       'الحارس الرقمي',
    impots:         'خبير الضرائب',
    cartevitale:    'خبير الصحة',
    rsacaf:         'خبير CAF',
    logement:       'خبير السكن',
    dossiermedical: 'خبير الملف الطبي',
    formation:      'خبير التكوين',
    permis:         'خبير الرخصة',
    banque:         'خبير البنك',
    smartphone:     'خبير الهاتف',
  },


  situations: {
    title: '🚨 هل لديك مشكلة الآن؟',
    subtitle: 'انقر على وضعك — سنرشدك مباشرة.',
    courrier: "تلقيت رسالة رسمية لا أفهمها",
    courrierSub: 'CAF، الضرائب، البلدية…',
    pdf: "طُلب مني ملء أو توقيع استمارة",
    pdfSub: 'PDF، استمارة رسمية، وثيقة إلكترونية…',
    caf: "أريد معرفة حقوقي والمساعدات المتاحة",
    cafSub: 'RSA، APL، المنح العائلية، CAF…',
    sante: "لدي سؤال حول صحتي أو التعويضات",
    santeSub: 'Carte Vitale، Ameli، التأمين الصحي…',
    logement: "لدي مشكلة في السكن",
    logementSub: 'الإيجار، الطرد، APL، السكن الاجتماعي…',
  },
  marie: {
    title: 'ماري، 62 عاماً — رسالة CAF وصلت هذا الصباح',
    desc: 'اللغة الإدارية، ملء ملف PDF، مسح وثيقة — كل هذا يتجاوزها. مع DémarchesClaires، تُنجز إجراءاتها وحدها،',
    highlight: 'في أقل من 15 دقيقة',
    badge1: 'مجاني',
    badge2: 'بدون تسجيل',
    badge3: 'بدون حكم',
  },

  quefaire: {
    title: 'رسالة تقلقك؟',
    sub: 'نخبرك بما تعنيه وما يجب عليك فعله — بكلمات بسيطة.',
  },

  contact: {
    title: 'راسلنا',
    sub: 'سؤال؟ اقتراح؟ اكتب لنا.',
    name: 'اسمك *',
    email: 'بريدك الإلكتروني (للرد عليك)',
    message: 'رسالتك *',
    send: 'إرسال الرسالة',
    sending: 'جارٍ الإرسال...',
    ok: '✅ تم الإرسال! شكراً.',
    err: '❌ خطأ. حاول مجدداً.',
  },

  errors: {
    moduleNotFound: 'الدرس غير موجود',
  },
  stickyFooter: {
    title: "لا تعرف من أين تبدأ ؟",
    subtitle: "3 أسئلة ← مسارك الشخصي",
    cta: "← اختبار تشخيصي مجاني",
  },
  heroV2: {
    hero_title: "\u062a\u0648\u0642\u0641 \u0639\u0646 \u0627\u0644\u0645\u0639\u0627\u0646\u0627\u0629 \u0645\u0639\n\u0627\u0644\u0625\u062c\u0631\u0627\u0621\u0627\u062a \u0627\u0644\u0625\u062f\u0627\u0631\u064a\u0629",
    hero_subtitle: "\u0627\u0644\u0635\u0642 \u0631\u0633\u0627\u0644\u062a\u0643. \u064a\u062d\u0644\u0644\u0647\u0627 \u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064a \u0648\u064a\u0631\u0634\u062f\u0643 \u0641\u064a 5 \u062b\u0648\u0627\u0646\u0650.",
    hero_badge: "\u0630\u0643\u0627\u0621 \u0627\u0635\u0637\u0646\u0627\u0639\u064a \u00b7 7 \u0644\u063a\u0627\u062a \u00b7 \u0645\u062c\u0627\u0646\u064a",
    hero_cta_main: "\u26a1 \u062a\u062d\u0644\u064a\u0644 \u0627\u0644\u0622\u0646",
    hero_cta_demo: "\u0645\u0634\u0627\u0647\u062f\u0629 \u0627\u0644\u0639\u0631\u0636 (30 \u062b\u0627\u0646\u064a\u0629)",
    hero_reassurance1: "\u2713 \u0628\u062f\u0648\u0646 \u062a\u0633\u062c\u064a\u0644",
    hero_reassurance2: "\u2713 \u0627\u0644\u0628\u064a\u0627\u0646\u0627\u062a \u062a\u064f\u062d\u0630\u0641 \u0628\u0639\u062f \u0627\u0644\u062a\u062d\u0644\u064a\u0644",
    demo_title: "\u0634\u0627\u0647\u062f \u0627\u0644\u0646\u062a\u064a\u062c\u0629 \u0642\u0628\u0644 \u0627\u0644\u0628\u062f\u0621",
    demo_subtitle: "\u0647\u0630\u0627 \u0645\u0627 \u064a\u064f\u0646\u062a\u062c\u0647 \u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064a \u0641\u064a 5 \u062b\u0648\u0627\u0646\u0650 \u0645\u0639 \u0631\u0633\u0627\u0644\u0629 \u062d\u0642\u064a\u0642\u064a\u0629",
    demo_analyse: "Mistral \u064a\u062d\u0644\u0644 \u0631\u0633\u0627\u0644\u062a\u0643",
    demo_cta: "\u062a\u062d\u0644\u064a\u0644 \u0631\u0633\u0627\u0644\u062a\u064a \u2190",
    demo_courrier: "\u0633\u064a\u062f\u064a/\u0633\u064a\u062f\u062a\u064a \u0627\u0644\u0639\u0632\u064a\u0632\u0629\u060c\n\u0646\u0639\u0644\u0645\u0643\u0645 \u0628\u0623\u0646 \u0645\u0644\u0641\u0643\u0645 \u0641\u064a CAF \u0631\u0642\u0645 2847156 \u0642\u062f \u062a\u0645 \u062a\u0639\u0644\u064a\u0642\u0647. \u064a\u062c\u0628 \u0639\u0644\u064a\u0643\u0645 \u062a\u0642\u062f\u064a\u0645 \u0625\u062b\u0628\u0627\u062a\u0627\u062a \u0627\u0644\u062f\u062e\u0644 \u0642\u0628\u0644 18 \u0641\u0628\u0631\u0627\u064a\u0631 2026.",
    demo_reponse: "\ud83d\udccb CAF \u0639\u0644\u0651\u0642 \u0645\u062e\u0635\u0635\u0627\u062a\u0643\n\n\u2705 \u0645\u0627 \u064a\u062c\u0628 \u0641\u0639\u0644\u0647:\n1. \u062c\u0645\u0639 \u0643\u0634\u0648\u0641 \u0627\u0644\u0631\u0627\u062a\u0628 (\u0622\u062e\u0631 3 \u0623\u0634\u0647\u0631)\n2. \u0625\u0631\u0633\u0627\u0644\u0647\u0627 \u0639\u0628\u0631 caf.fr \u0623\u0648 \u0634\u062e\u0635\u064a\u0627\u064b\n\u23f0 \u0627\u0644\u0645\u0648\u0639\u062f \u0627\u0644\u0646\u0647\u0627\u0626\u064a: \u0642\u0628\u0644 18 \u0641\u0628\u0631\u0627\u064a\u0631 \u2014 \u0639\u0627\u062c\u0644!",
  },
};
